















import { Prop, Component, Vue } from "vue-property-decorator";
import { deleteProject, ProjectProperty } from "@/api/project-api";
import { Client, getAllClients, getAllClientStaffs } from "@/api/client-api";
import { Staff } from "@/api/company-api";
import { Company, Office } from "@/api/company-api";
import SelectOption from "@/common/ui/presenters/select-option";
import ProjectEdit from "../templates/ProjectEdit.vue";
import ProjectTemplate from "../models/project-template";
import createProjectOutput from "../api/models/factories/createProjectOutput";
import createOrderOutput from "../api/models/factories/createOrderOutput";
import UploadFileSpec from "../models/specs/UploadFileSpec";
import createCompany from "@/helpers/createCompany";
import { templateApi } from "../api";
import emitter from "../EventBus";
import formatDate from "@/helpers/formatDate";

@Component({
  components: {
    ProjectEdit
  }
})
export default class ProjectEditPage extends Vue {
  @Prop({ required: true }) projectId!: string;

  project = createProjectOutput();
  order = createOrderOutput();
  company: Company | null = null;
  office: Office | null = null;
  private templateList: ProjectTemplate[] = [];

  get clientOptions(): SelectOption[] {
    return this.clientList.map(c => ({
      text: c.name,
      value: String(c.id)
    }));
  }

  get clientStaffOptions(): SelectOption[] {
    return this.filteredClientStaffList.map(s => ({
      text: s.name,
      value: String(s.staffId)
    }));
  }

  updateIcon(e: Event) {
    const files = (e.target as HTMLInputElement).files;
    if (!files || !files[0]) return;
    const spec = new UploadFileSpec();
    if (!spec.isSatisfied(files[0])) {
      alert(spec.errors);
      return;
    }
    const url = URL.createObjectURL(files[0]);
    this.project.icon = url;
    this.project.iconFile = files[0];
  }

  get templateOptions(): SelectOption[] {
    return this.templateList.map(t => new SelectOption(t, "id", "title"));
  }

  private async initTemplateList() {
    this.templateList = await templateApi.getAll();
  }

  async ok(hasEndDateChanged = false) {
    if (
      this.project.closed &&
      !hasEndDateChanged &&
      !confirm("本当に現場を終了してもよろしいですか？")
    ) {
      return;
    }
    await this.saveProject();
  }

  cancel() {
    this.goShowPage();
  }

  async remove() {
    await this.deleteProject();
    this.goHome();
  }

  private clientList: Client[] = [];
  private clientStaffList: Staff[] = [];

  private get filteredClientStaffList(): Staff[] {
    if (!this.order) return this.clientStaffList;
    const cid = this.order.clientId;
    if (!cid) return this.clientStaffList;
    return this.clientStaffList.filter(
      s => cid === String(s.officeId) && s.isHiddenInfo === 0
    );
  }
  private created() {
    [this.company, this.office] = createCompany();
    this.$store.dispatch("initProject", this.projectId);
    this.initProject();
    this.initClientList();
    this.initClientStaffList();
  }

  taskDefaults = [];
  private async initProject() {
    const p = this.$store.state.project;
    this.project = {
      id: String(p.projectId),
      name: p.name,
      icon: p.icon,
      iconFile: null,
      postcode: p.postcode,
      address: p.address,
      latitude: p.latitude,
      longitude: p.longitude,
      start: p.start,
      end: p.end,
      note: p.note,
      state: p.state,
      closed: p.closed,
      tgId: p.tgId,
      sSystemId: p.sSystemId,
      OHANo: p.OHANo,
      holdOut: p.holdOut,
      templateId: p.templateId,
      beforeTemplateId: p.beforeTemplateId,
      additionalProperties: this.additionalProperties,
      taskDefaults: p.taskDefaults,
      contractDate: p.contractDate,
      created: formatDate(p.created),
      constructionType: p.constructionType ? p.constructionType.id : "",
      responsiblePerson: p.responsiblePerson
    };
    this.order = {
      id: String(p.orderId),
      clientId: String(p.client.office.officeId),
      clientStaffId: String(p.clientStaff.staffId),
      state: 1,
      endUser: ""
    };
  }

  private async initClientList() {
    this.clientList = await getAllClients();
  }

  private async initClientStaffList() {
    this.clientStaffList = await getAllClientStaffs();
  }

  private async saveProject() {
    if (!this.company || !this.office) return;
    if (!this.order.endUser) {
      try {
        await this.$store.dispatch("saveProject", {
          project: this.project,
          order: this.order
        });

        this.goShowPage();
        this.$store.dispatch("getStatusProject");
      } catch (e) {
        emitter.emit("message", e);
      }
    } else {
      try {
        await this.$store.dispatch("saveEndUserProject", {
          project: this.project,
          order: this.order,
          company: this.company,
          office: this.office
        });

        this.goShowPage();
        this.$store.dispatch("getStatusProject");
      } catch (e) {
        emitter.emit("message", e);
      }
    }
  }

  private async deleteProject() {
    await deleteProject(this.projectId);
  }

  private goHome() {
    this.$router.push("/");
  }

  private goShowPage() {
    const params = { id: this.projectId };
    this.$router.push({ name: "project-details", params });
  }

  get additionalProperties() {
    const additionalProperties = this.$store.state.project.additionalProperties;
    return additionalProperties.filter(
      (item: ProjectProperty) => !item.key.deletedAt
    );
  }
}
